import { zodResolver } from '@hookform/resolvers/zod'
import { Email } from '@numistic/contracts'
import { useRequestPasswordReset } from '@numistic/data'
import { useTranslation } from '@numistic/i18n'
import { Alert, Button, Field, Input } from '@numistic/ui'
import { createRoute, Link } from '@tanstack/react-router'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

import { AuthCard } from '../../components/auth-card.js'
import { useErrorText } from '../../lib/errors.js'
import { rootRoute } from '../root.js'

export const forgotPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/forgot-password',
  component: ForgotPasswordPage,
})

const FormSchema = z.object({ email: Email })

function ForgotPasswordPage() {
  const { t } = useTranslation()
  const errorText = useErrorText()
  const request = useRequestPasswordReset()
  const form = useForm({ resolver: zodResolver(FormSchema), defaultValues: { email: '' } })

  const onSubmit = form.handleSubmit(({ email }) =>
    request.mutate({ email, redirectTo: '/reset-password' }),
  )

  return (
    <AuthCard title={t('auth.forgotTitle')} description={t('auth.forgotHint')}>
      {request.isSuccess ? (
        <div className="grid gap-4">
          <Alert variant="success">{t('auth.forgotSent')}</Alert>
          <Link
            to="/login"
            className="text-center text-sm text-muted-foreground hover:text-foreground"
          >
            {t('auth.backToSignIn')}
          </Link>
        </div>
      ) : (
        <form className="grid gap-4" onSubmit={onSubmit} noValidate>
          {request.error ? (
            <Alert variant="destructive">{errorText.request(request.error)}</Alert>
          ) : null}
          <Field label={t('auth.email')} error={errorText.field(form.formState.errors.email)}>
            <Input type="email" autoComplete="email" autoFocus {...form.register('email')} />
          </Field>
          <Button type="submit" disabled={request.isPending}>
            {t('auth.forgotSubmit')}
          </Button>
        </form>
      )}
    </AuthCard>
  )
}
